import { LogLevel } from '@azure/msal-browser';

// Helper function to get environment variables from runtime config or build-time process.env
export const getEnvVar = (key) => {
  // Try runtime config first (set by start.sh in production)
  if (window.ENV && window.ENV[key]) {
    console.log(`[AuthConfig] Using runtime config for ${key}:`, window.ENV[key]);
    return window.ENV[key];
  }
  // Fall back to build-time environment variables (for local development)
  const buildTimeValue = process.env[key];
  console.log(`[AuthConfig] Using build-time config for ${key}:`, buildTimeValue);
  return buildTimeValue;
};

// Create msalConfig function that builds config when called (after window.ENV is available)
export const getMsalConfig = () => {
  const redirectUri = getEnvVar('REACT_APP_AZURE_REDIRECT_URI') || window.location.origin + '/auth/callback';
  console.log('[AuthConfig] Final redirect URI:', redirectUri);
  console.log('[AuthConfig] window.location.origin:', window.location.origin);
  console.log('[AuthConfig] window.ENV available:', !!window.ENV);

  return {
    auth: {
      clientId: getEnvVar('REACT_APP_AZURE_CLIENT_ID'),
      authority: `https://login.microsoftonline.com/${getEnvVar('REACT_APP_AZURE_TENANT_ID')}`,
      redirectUri: redirectUri,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        },
      },
    },
  };
};

export const getLoginRequest = () => ({
  scopes: (getEnvVar('REACT_APP_AZURE_SCOPES') || 'openid,profile,email,User.Read').split(','),
});

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

// Admin email list from environment variable
export const adminEmails = getEnvVar('REACT_APP_ADMIN_EMAILS')
  ? getEnvVar('REACT_APP_ADMIN_EMAILS').split(',').map(email => email.trim())
  : [];